// employees/slice.js

import { employeesInitialState } from "./employeesState";
import { makeEmployeesActions } from "./employeesActions";

export const createEmployeesSlice = (set, get) => ({
  employees: employeesInitialState,
  employeesActions: Object.freeze(makeEmployeesActions(set, get)),
});
